var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.projects),function(project){return _c('div',{key:project.uid},[_c('ProjectCard',{attrs:{"project":project,"joinEnable":_vm.joinEnable(project),"onClickJoin":_vm.onClickJoin,"needLogin":_vm.needLogin()}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }